import { createSelector } from '@ngrx/store';
import { availablePickupsState } from '../root';

export const getAvailablePickupTimesForAllLocations = createSelector(availablePickupsState, (availablePickups) => availablePickups);
